import "../../styles/templates/product.scss";
import '../snippets/product-gallery.js';
import '../components/back-in-stock.js';
import RecipientForm from '../components/recipient-form.js'

$(function () {
  $('.product-template').on('variantChange', function (e) {
    if (e.variant) {
      $('.product__form__main-info [data-variant-sku]').html(e.variant.sku);
    }
  });

  RecipientForm();


});

const WISHLIST_EVENT_TYPE = {
  addToCart: 4,
}

const WISHLIST_KEYS = {
  productId: 'empi',
  variantId: 'epi',
  productUrl: 'du',
  vendor: 'bt'
}

const getSelectedVariantId = function (context = document) {
  const variantIdInput = context.querySelector('[name="id"]');

  if (variantIdInput) {
    return variantIdInput.value
  }
}

const UISetWishlistToggle = function (wishlistButton, add = true) {
  const addedClass = 'swym-added';
  if (add) {
    wishlistButton.classList.add(addedClass);
  } else {
    wishlistButton.classList.remove(addedClass);
  }
}

const decorateProductForWishlist = function (SwymPageData, variantInputId) {
  if (variantInputId) {
    SwymPageData[WISHLIST_KEYS.variantId] = variantInputId;
  }

  SwymPageData[WISHLIST_KEYS.vendor] = SwymProductInfo.product.vendor;
  SwymPageData[WISHLIST_KEYS.productUrl] = window.location.href;
}

function addToWishlist() {
  const wishlistButton = document.querySelector(".swym-add-to-wishlist-view-product");
  const productSection = document.querySelector('.product-template');
  const productForm = document.querySelector('form[data-product-form]');

  if (wishlistButton && productForm) {
    const productId = window.SwymProductInfo.product.id || productForm.getAttribute('data-product-form');

    const updateCurrentProductWishlistButton = async function () {
      if (productId) {
        await _swat.fetchWrtEventTypeET(function (products) {
          const variantId = getSelectedVariantId(productForm);

          const productInWishlist = products.find(product => product[WISHLIST_KEYS.variantId] == variantId);

          if (!productInWishlist) {
            UISetWishlistToggle(wishlistButton, false);
          } else {
            UISetWishlistToggle(wishlistButton, true);
          }
        }, _swat.EventTypes.addToWishlist);
      }
    }

    wishlistButton.addEventListener("click", function (e) {
      if (SwymPageData) {
        SwymPageData.et = WISHLIST_EVENT_TYPE.addToCart; // et 4 stands for wishlist event type

        const variantInputId = productForm.querySelector('name[id]');

        decorateProductForWishlist(SwymPageData, variantInputId);

        if (wishlistButton.classList.contains('swym-added')) {
          _swat.removeFromWishList(SwymPageData, function (e) {
            UISetWishlistToggle(wishlistButton, false);
          });
        } else {
          _swat.addToWishList(SwymPageData, function (e) {
            UISetWishlistToggle(wishlistButton, true);
          });
        }
      }
    });


    $(productSection).on('variantChange', updateCurrentProductWishlistButton); // onVariantChange
    updateCurrentProductWishlistButton(); // Onload
  }
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(addToWishlist);
